<template>
  <div class="content background1" style="padding: 10px">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="alarm-search">
            <div class="alarm-search-list">
              <div style="width: auto; display: flex; justify-content: flex-start">
                <div class="alarm-search-black" style="min-width: 300px">
                  <label class="alarm-search-label" style="min-width: 130px;">{{$t('label_127')}}</label>
                  <div class="alarm-search-condition">
                    <ul class="alarm-search-condition-list">
                      <li :class="{
                    on:
                      searchParam.source.length === 0 ||
                      searchParam.source.indexOf(item.id) != -1,
                  }" v-for="(item, index) in alarmSourceList" :key="index" @click="clickSource(item.id)">
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="alarm-search-black" style="min-width: 300px">
                  <label class="alarm-search-label" style="min-width: 130px;">{{$t('label_132')}}</label>
                  <div class="alarm-search-condition">
                    <ul class="alarm-search-condition-list">
                      <li :class="{
                    on:
                      searchParam.state.length === 0 ||
                      searchParam.state.indexOf(item.id) != -1,
                  }" v-for="(item, index) in alarmStateList" :key="index" @click="clickState(item.id)">
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="alarm-search-black" style="min-width: 190px">
                  <label class="alarm-search-label">{{$t('label_136')}}</label>
                  <div class="alarm-search-condition">
                    <el-date-picker class="date-class" :clearable="false" v-model="searchParam.startTime"
                                    type="date" value-format="yyyy-MM-dd" :placeholder="$t('label_136')">
                    </el-date-picker>
                  </div>
                </div>
                <div class="alarm-search-black" style="min-width: 190px">
                  <label class="alarm-search-label" style="min-width: 20px">{{$t('label_264')}}</label>
                  <div class="alarm-search-condition">
                    <el-date-picker class="date-class" :clearable="false" v-model="searchParam.startTime2"
                                    type="date" value-format="yyyy-MM-dd" :placeholder="$t('label_136')">
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="alarm-search-black" style="min-width: 100px; width: auto">
                <button class="alarm-search-btn" @click="search({ pageNo: 1, pageSize: pageSize })">
                  <img src="../../assets/img/common/search_icon.png" style="padding-right: 5px; height: 12px"/>{{$t('btn_2')}}
                </button>
              </div>
            </div>
            <div class="alarm-search-list">
              <div style="width: auto; display: flex; justify-content: flex-start">
                <div class="alarm-search-black" style="min-width: 300px; width: 300px">
                  <label class="alarm-search-label">{{$t('label_268')}}</label>
                  <div class="alarm-search-condition">
                    <el-select class="select-class" v-model="searchParam.customerType" :placeholder="$t('input_65')">
                      <el-option :label="$t('label_272')" :value="''"></el-option>
                      <el-option v-for="(item, index) in customerTypeList" :label="item.name" :value="item.id"
                                 :key="index">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="alarm-search-black">
                  <label class="alarm-search-label" style="min-width: 130px;">{{$t('label_139')}}</label>
                  <div class="alarm-search-condition">
                    <el-checkbox-group v-model="searchParam.error" :min="1" v-if="alarmTypeList.length > 0">
                      <el-checkbox v-for="(item, index) in alarmTypeList" :label="item.id" :key="index">
                        {{ item.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="alarm-search-2">
            <ul>
              <el-checkbox-group v-model="workOrderState" :min="1">
                <li :class="{ on: workOrderState.indexOf(0) >= 0 }" @click="searchState(0)">
                  <div class="icon">
                    <img src="../../assets/img/alarm/pending-icon.png"/>
                  </div>
                  <div class="info">
                    <div class="info-title">{{$t('label_142')}}</div>
                    <div class="info-count">{{ stateList[0] }}</div>
                  </div>
                  <div class="checkbox">
                    <el-checkbox class="search2-checkbox" :label="0" @change="searchState(0)"></el-checkbox>
                  </div>
                </li>
                <li :class="{ on: workOrderState.indexOf(1) >= 0 }" @click="searchState(1)">
                  <div class="icon">
                    <img src="../../assets/img/alarm/received-icon.png"/>
                  </div>
                  <div class="info">
                    <div class="info-title">{{$t('label_428')}}</div>
                    <div class="info-count">{{ stateList[1] }}</div>
                  </div>
                  <div class="checkbox">
                    <el-checkbox class="search2-checkbox" :label="1" @change="searchState(1)"></el-checkbox>
                  </div>
                </li>
                <li :class="{ on: workOrderState.indexOf(2) >= 0 }" @click="searchState(2)">
                  <div class="icon">
                    <img src="../../assets/img/alarm/finished-icon.png"/>
                  </div>
                  <div class="info">
                    <div class="info-title">{{$t('label_69')}}</div>
                    <div class="info-count">{{ stateList[2] }}</div>
                  </div>
                  <div class="checkbox">
                    <el-checkbox class="search2-checkbox" :label="2" @change="searchState(2)"></el-checkbox>
                  </div>
                </li>
                <li :class="{ on: workOrderState.indexOf(7) >= 0 }" @click="searchState(7)">
                  <div class="icon">
                    <img src="../../assets/img/alarm/evaluated-icon.png"/>
                  </div>
                  <div class="info">
                    <div class="info-title">{{$t('label_150')}}</div>
                    <div class="info-count">{{ stateList[7] }}</div>
                  </div>
                  <div class="checkbox">
                    <el-checkbox class="search2-checkbox" :label="7" @change="searchState(7)"></el-checkbox>
                  </div>
                </li>
                <li :class="{ on: workOrderState.indexOf(4) >= 0 }" @click="searchState(4)">
                  <div class="overtime">{{$t('label_159')}}</div>
                  <div class="icon">
                    <img src="../../assets/img/alarm/missed-icon.png"/>
                  </div>
                  <div class="info">
                    <div class="info-title">{{$t('label_430')}}</div>
                    <div class="info-count">{{ stateList[4] }}</div>
                  </div>
                  <div class="checkbox">
                    <el-checkbox class="search2-checkbox" :label="4" @change="searchState(4)"></el-checkbox>
                  </div>
                </li>
                <li :class="{ on: workOrderState.indexOf(5) >= 0 }" @click="searchState(5)">
                  <div class="overtime">{{$t('label_164')}}</div>
                  <div class="icon">
                    <img src="../../assets/img/alarm/missed-icon.png"/>
                  </div>
                  <div class="info">
                    <div class="info-title">{{$t('label_154')}}</div>
                    <div class="info-count">{{ stateList[5] }}</div>
                  </div>
                  <div class="checkbox">
                    <el-checkbox class="search2-checkbox" :label="5" @change="searchState(5)"></el-checkbox>
                  </div>
                </li>
              </el-checkbox-group>
            </ul>
          </div>
          <div class="alarm-list">
            <div class="alarm-list-btnList">
              <div class="alarm-list-title">
                <div class="list-title">
                  <span></span>
                  <audio src="https://www.sfrsafety.com/static/img/warn.wav"></audio>
                  {{$t('label_169')}}
                  <div style="margin-right: 10px; display: flex">
                    <button class="alarm-list-btn-1" @click="showDetails">
                      {{$t('btn_6')}}
                    </button>
                    <button class="alarm-list-btn-2" @click="showDistribution">
                      {{$t('btn_4')}}
                    </button>
                    <!--<excel-export :filename="utils.getNowFormatDate() + '报警列表'" :sheet="sheet">
                      <button class="alarm-list-btn-1">
                        <img src="../../assets/img/common/export_icon.png"
                          style="padding-right: 5px; height: 12px"
                          v-if="menuList.indexOf('CD_210') != -1" />导出
                      </button>
                    </excel-export>-->
                  </div>

                  <div class="searchSwitch">
                    <el-switch v-model="searchSwitch" @change="searchSwitchChange" :active-text="$t('label_188')"
                               :inactive-text="$t('label_184')">
                    </el-switch>
                  </div>
                </div>

                <div class="list-status">
                  <ul>
                    <li>
                      <div class="status1"></div>
                      {{$t('label_136')}}
                    </li>
                    <li>
                      <div class="status2"></div>
                      {{$t('label_197')}}
                    </li>
                    <li>
                      <div class="status3"></div>
                      {{$t('label_201')}}
                    </li>
                    <li>
                      <div class="status4"></div>
                      {{$t('label_205')}}
                    </li>
                    <li>
                      <div class="status5"></div>
                      {{$t('label_210')}}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="list-table">
                <el-table :empty-text="$t('label_357')" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                          :row-class-name="tableRowClassName" height="460" highlight-current-row :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
                          @current-change="handleCurrentChange" :stripe="true" :cell-style="{ textAlign: 'center'}">
                  <el-table-column type="index" header-align="center" align="center" :index="getIndex" :label="$t('label_369') + '.'"
                                   width="60">
                  </el-table-column>
                  <el-table-column prop="customerName" :label="$t('label_213')" align="left" width="250"
                                   style="text-align: left;">
                    <template slot-scope="scope">
                      <template>
                        <div style="text-align: left;">
                          <span style="text-align: left;">{{ scope.row.customerName }}</span><br>
                          <span style="text-align: left; font-size: 8px; ">{{ scope.row.address }}</span>
                        </div>
                      </template>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="address" label="客户地址" header-align="center">
                    <template slot-scope="scope">
                      <template><span>{{ scope.row.address }}</span></template>
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="deviceCode" :label="$t('label_215')" header-align="center" width="180">
                    <template slot-scope="scope">
                      <template>
                        <span>{{ scope.row.deviceCode }}</span><br>
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="name" label="设备型号" header-align="center">
                    <template slot-scope="scope">
                      <template><span>{{ scope.row.name }}</span></template>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column prop="probeAddress" :label="$t('label_218')" header-align="center">
                    <template slot-scope="scope">
                      <template><span>{{ scope.row.probeAddress }}</span></template>
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="source" :label="$t('label_465')" header-align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <template v-for="item in alarmSourceList"
                                v-if="scope.row.source === item.id + ''"><span>{{ item.name }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('label_132')" header-align="center" align="center" width="80"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="alarm-status">
									<span class="error" v-if="
                      alarmStateList.length > 0 &&
                      scope.row.state == alarmStateList[0].id
                    ">{{ alarmStateList[0].name }}</span>
                        <span class="normal" v-if="
                      alarmStateList.length > 0 &&
                      scope.row.state == alarmStateList[1].id
                    ">{{ alarmStateList[1].name }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="error" :label="$t('label_465')" header-align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <template v-for="item in alarmTypeList"
                                v-if="scope.row.error === item.id + ''"><span>{{ item.name }}</span>
                      </template>
                      <br>
                      <template><span>{{ scope.row.content }}</span></template>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column prop="content" label="故障内容" align="center" header-align="center" width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <template><span>{{ scope.row.content }}</span></template>
                    </template>
                  </el-table-column> -->
                  <el-table-column :label="$t('label_147')" header-align="center" width="200">
                    <template slot-scope="scope">
                      <ul class="time-list">
                        <li>
                          <div class="status1"></div>
                          <template><span>{{ scope.row.startTime }}</span></template>
                        </li>
                        <li>
                          <div class="status2"></div>
                          <template
                            v-if="scope.row.receiveTime != null"><span>{{ scope.row.receiveTime }}</span></template>
                          <template
                            v-else><span>--</span></template>
                        </li>
                        <li>
                          <div class="status3"></div>
                          <template
                            v-if="scope.row.arrivalTime != null"><span>{{ scope.row.arrivalTime }}</span></template>
                          <template
                            v-else><span>--</span></template>
                        </li>
                        <li>
                          <div class="status4"></div>
                          <template
                            v-if="scope.row.completionTime != null"><span>{{ scope.row.completionTime }}</span>
                          </template>
                          <template
                            v-else><span>--</span></template>
                        </li>
                        <li>
                          <div class="status5"></div>
                          <template
                            v-if="scope.row.endTime != null"><span>{{ scope.row.endTime }}</span></template>
                          <template
                            v-else><span>--</span></template>
                        </li>
                      </ul>
                    </template>
                  </el-table-column>
                  <el-table-column prop="orderState" :label="$t('label_25')" header-align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <template v-for="item in orderStateList"
                                v-if="scope.row.orderState == item.id"><span>{{ item.name }}</span></template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('label_109')" header-align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <ul class="user-list">
                        <li>
                          <img src="../../assets/img/alarm/personnel-icon.png"
                               style="height: 14px; width: 14px; margin-right: 5px"/><span>{{ scope.row.supportPerson }}</span>
                        </li>
                        <li>
                          <div style="width: 19px; height: auto"></div>
                          <span>{{ scope.row.helper }}</span>
                        </li>
                      </ul>
                    </template>
                  </el-table-column>
                  <el-table-column prop="workNotes" :label="$t('btn_29')" header-align="center">
                    <template slot-scope="scope">
                      <template><span>{{ scope.row.workNotes }}</span></template>
                    </template>
                  </el-table-column>
                </el-table>
                <div ref="page" class="page">
                  <Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                        @parentMethod="search"></Page>
                </div>
              </div>
            </div>
          </div>

          <div class="drawer" v-show="distribution">
            <div>
              <div class="drawer-title">
                <div class="drawer-label">{{$t('btn_4')}}</div>
                <div class="drawer-btn" @click="distribution = false">×</div>
              </div>
              <div class="customer-title">
                <div class="customer-title-label">{{ detail.customerName }}</div>
                <template v-if="
              alarmStateList.length > 0 && detail.state == alarmStateList[0].id
            ">
                  <div class="customer-title-status">
                    <img src="../../assets/img/alarm/alarm-icon.png"/>{{
                    alarmStateList[0].name
                    }}
                  </div>
                </template>
                <template v-if="
              alarmStateList.length > 0 && detail.state == alarmStateList[1].id
            ">
                  <div class="customer-title-status" style="background-color: #2bbc86">
                    <img src="../../assets/img/alarm/alarm-icon.png"/>{{
                    alarmStateList[1].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[0].id
            ">
                  <div class="customer-title-err">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[0].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[1].id
            ">
                  <div class="customer-title-err" style="background: #4492fb">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[1].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[2].id
            ">
                  <div class="customer-title-err" style="background: #2bbc86">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[2].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[3].id
            ">
                  <div class="customer-title-err" style="background: #ffd328">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[3].name
                    }}
                  </div>
                </template>
                <!-- <template v-if="orderStateList.length>0 && detail.orderState == orderStateList[4].id">
                    <div class="customer-title-err" style="background-color: #F48164;"><img
                        src="../../assets/img/alarm/alarm-missed-icon.png">{{orderStateList[4].name}}</div>
                </template>
                <template v-if="orderStateList.length>0 && detail.orderState == orderStateList[5].id">
                    <div class="customer-title-err" style="background-color: #F48164;"><img
                        src="../../assets/img/alarm/alarm-missed-icon.png">{{orderStateList[5].name}}</div>
                </template> -->
              </div>
              <div class="customer-user">
                <div>
                  {{$t('label_224')}}：
                  <template v-if="detail.supportPerson != null">{{
                    detail.supportPersonName
                    }}
                  </template>
                  <template v-else>--</template>
                </div>
                <div>
                  {{$t('label_227')}}：
                  <template v-if="detail.helper != null">{{
                    detail.helperName
                    }}
                  </template>
                  <template v-else>--</template>
                </div>
              </div>
              <div class="alarm-customer-info">
                <ul class="customer-info-param">
                  <li>
                    <div class="info-title">{{$t('label_230')}}</div>
                    <div class="info-param">
                      {{ detail.province }}{{ detail.city }}{{ detail.district
                      }}{{ detail.town }}{{ detail.address }}
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_127')}}</div>
                    <div class="info-param">
                      <template v-for="item in alarmSourceList"
                                v-if="detail.source === item.id + ''">{{ item.name }}
                      </template>
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_139')}}</div>
                    <div class="info-param">
                      <template v-for="item in alarmTypeList"
                                v-if="detail.error === item.id + ''">{{ item.name }}
                      </template>
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_233')}}</div>
                    <div class="info-param">{{ detail.deviceCode }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_237')}}</div>
                    <div class="info-param">{{ detail.startTime }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_241')}}</div>
                    <div class="info-param">{{ detail.content }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_80')}}</div>
                    <div class="info-param">{{ detail.workNotes }}</div>
                  </li>
                </ul>
              </div>
              <div class="customer-responsible-user">
                <div class="customer-responsible-user-label">{{$t('label_83')}}</div>
                <el-autocomplete class="customer-responsible-user-input" style="width: 100%" v-model="supportPerson"
                                 :fetch-suggestions="queryStaff1" @select="selectStaff1" :trigger-on-focus="false"
                                 value-key="fullName" :placeholder="$t('input_6')">
                </el-autocomplete>
              </div>
              <div class="customer-coordination-user">
                <div class="customer-coordination-user-label">{{$t('label_86')}}</div>
                <el-autocomplete class="customer-responsible-user-input" style="width: 100%" v-model="helper"
                                 :fetch-suggestions="queryStaff1" @select="selectStaff2" :trigger-on-focus="false"
                                 value-key="fullName" :placeholder="$t('input_7')">
                </el-autocomplete>
              </div>
              <div class="customer-btn">
                <button @click="editAlarm">{{$t('btn_4')}}</button>
              </div>
            </div>
          </div>
          <div class="drawer" v-show="details">
            <div>
              <div class="drawer-title">
                <div class="drawer-label">{{$t('btn_6')}}</div>
                <div class="drawer-btn" @click="details = false">×</div>
              </div>
              <div class="customer-title">
                <div class="customer-title-label">{{ detail.customerName }}</div>
                <template v-if="
              alarmStateList.length > 0 && detail.state == alarmStateList[0].id
            ">
                  <div class="customer-title-status">
                    <img src="../../assets/img/alarm/alarm-icon.png"/>{{
                    alarmStateList[0].name
                    }}
                  </div>
                </template>
                <template v-if="
              alarmStateList.length > 0 && detail.state == alarmStateList[1].id
            ">
                  <div class="customer-title-status" style="background-color: #2bbc86">
                    <img src="../../assets/img/alarm/alarm-icon.png"/>{{
                    alarmStateList[1].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[0].id
            ">
                  <div class="customer-title-err">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[0].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[1].id
            ">
                  <div class="customer-title-err" style="background: #4492fb">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[1].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[2].id
            ">
                  <div class="customer-title-err" style="background: #2bbc86">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[2].name
                    }}
                  </div>
                </template>
                <template v-if="
              orderStateList.length > 0 &&
              detail.orderState == orderStateList[3].id
            ">
                  <div class="customer-title-err" style="background: #ffd328">
                    <img src="../../assets/img/alarm/alarm-missed-icon.png"/>{{
                    orderStateList[3].name
                    }}
                  </div>
                </template>
                <!-- <template v-if="orderStateList.length>0 && detail.orderState == orderStateList[4].id">
                     <div class="customer-title-err" style="background-color: #F48164;"><img
                         src="../../assets/img/alarm/alarm-missed-icon.png">{{orderStateList[4].name}}</div>
                 </template>
                 <template v-if="orderStateList.length>0 && detail.orderState == orderStateList[5].id">
                     <div class="customer-title-err" style="background-color: #F48164;"><img
                         src="../../assets/img/alarm/alarm-missed-icon.png">{{orderStateList[5].name}}</div>
                 </template> -->
              </div>
              <div class="customer-user">
                <div>
                  {{$t('label_224')}}：
                  <template v-if="detail.supportPersonName != null">{{
                    detail.supportPersonName
                    }}
                  </template>
                  <template v-else>--</template>
                </div>
                <div>
                  {{$t('label_227')}}：
                  <template v-if="detail.helperName != null">{{
                    detail.helperName
                    }}
                  </template>
                  <template v-else>--</template>
                </div>
              </div>
              <div class="alarm-customer-info">
                <ul class="customer-info-param">
                  <li>
                    <div class="info-title">{{$t('label_230')}}</div>
                    <div class="info-param">
                      {{ detail.province }}{{ detail.city }}{{ detail.district
                      }}{{ detail.town }}{{ detail.address }}
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_127')}}</div>
                    <div class="info-param">
                      <template v-for="item in alarmSourceList"
                                v-if="detail.source === item.id + ''">{{ item.name }}
                      </template>
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_139')}}</div>
                    <div class="info-param">
                      <template v-for="item in alarmTypeList"
                                v-if="detail.error === item.id + ''">{{ item.name }}
                      </template>
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_233')}}</div>
                    <div class="info-param">{{ detail.deviceCode }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_237')}}</div>
                    <div class="info-param">{{ detail.startTime }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_241')}}</div>
                    <div class="info-param">{{ detail.content }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_80')}}</div>
                    <div class="info-param">{{ detail.workNotes }}</div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_484')}}</div>
                    <div class="info-param">
                      <!--<img
                        v-for="item in detail.workPics"
                        :src="'data:image/jpeg;base64,'+item"
                        style="width: 70px; height: 70px;margin: 0 5px;"
                      />-->
                      <span v-for="(item, index) in detail.workPics" :key="index">
									<!--<el-image
                 style="width: 70px; height: 70px;margin: 0 5px;"
                 :src="'data:image/jpeg;base64,'+item"
                 :preview-src-list="getImgList(item)">
                </el-image>-->
									<el-popover placement="top-start" title trigger="hover">
										<img :src="'data:image/jpeg;base64,' + item" alt
                         style="width: 250px; height: auto"/>
										<img slot="reference" :src="'data:image/jpeg;base64,' + item"
                         style="width: 70px; height: 70px; margin: 0 5px" @click="imgClick(index)"/>
									</el-popover>
								</span>
                    </div>
                  </li>
                  <li>
                    <div class="info-title">{{$t('label_247')}}</div>
                    <div class="info-param">
								<span v-for="(item, index) in detail.pics" :key="index">
									<el-popover placement="top-start" title trigger="hover">
										<img :src="'data:image/jpeg;base64,' + item" alt
                         style="width: 250px; height: auto"/>
										<img slot="reference" :src="'data:image/jpeg;base64,' + item"
                         style="width: 70px; height: 70px; margin: 0 5px"
                         @click="imgClickPics(index)"/>
									</el-popover>
								</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="alarm-time">
                <div class="alarm-time-label">
                  <img src="../../assets/img/alarm/detail-icon.png"
                       style="height: 16px; width: 12px; margin-right: 5px"/>{{$t('label_250')}}
                </div>
                <div class="alarm-time-list">
                  <ul>
                    <li>
                      <div class="alarm-time-list-top">
                        <div class="alarm-time-list-top-left">
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_237')}}
                          </div>
                          <div class="line" :class="{ incomplete: detail.endTime == null }"></div>
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_210')}}
                          </div>
                        </div>
                        <div class="alarm-time-list-top-right">
                          <img src="../../assets/img/alarm/error-time-icon.png"/>{{$t('故障时长')}}
                        </div>
                      </div>
                      <div class="alarm-time-list-bottom">
                        <div class="alarm-time-list-bottom-left">
                          <div class="startTime">{{ detail.startTime }}</div>
                          <div>{{ detail.endTime }}</div>
                        </div>
                        <div class="alarm-time-list-bottom-right">
                          {{ getTimeSection(detail.startTime, detail.endTime) }}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="alarm-time-list-top">
                        <div class="alarm-time-list-top-left">
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_237')}}
                          </div>
                          <div class="line" :class="{ incomplete: detail.receiveTime == null }"></div>
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_197')}}
                          </div>
                        </div>
                        <div class="alarm-time-list-top-right">
                          <img src="../../assets/img/alarm/receiving-time-icon.png"/>{{$t('接单时长')}}
                        </div>
                      </div>
                      <div class="alarm-time-list-bottom">
                        <div class="alarm-time-list-bottom-left">
                          <div class="startTime">{{ detail.startTime }}</div>
                          <div>{{ detail.receiveTime }}</div>
                        </div>
                        <div class="alarm-time-list-bottom-right">
                          {{ getTimeSection(detail.startTime, detail.receiveTime) }}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="alarm-time-list-top">
                        <div class="alarm-time-list-top-left">
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_197')}}
                          </div>
                          <div class="line" :class="{ incomplete: detail.arrivalTime == null }"></div>
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_201')}}
                          </div>
                        </div>
                        <div class="alarm-time-list-top-right">
                          <img src="../../assets/img/alarm/distance-time-icon.png"/>{{$t('路程时长')}}
                        </div>
                      </div>
                      <div class="alarm-time-list-bottom">
                        <div class="alarm-time-list-bottom-left">
                          <div class="startTime">{{ detail.receiveTime }}</div>
                          <div>{{ detail.arrivalTime }}</div>
                        </div>
                        <div class="alarm-time-list-bottom-right">
                          {{ getTimeSection(detail.receiveTime, detail.arrivalTime) }}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="alarm-time-list-top">
                        <div class="alarm-time-list-top-left">
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('到长时间')}}
                          </div>
                          <div class="line" :class="{ incomplete: detail.completionTime == null }"></div>
                          <div>
                            <img src="../../assets/img/alarm/alarm-time-icon.png"/>{{$t('label_205')}}
                          </div>
                        </div>
                        <div class="alarm-time-list-top-right">
                          <img src="../../assets/img/alarm/handle-time-icon.png"/>{{$t('处理时长')}}
                        </div>
                      </div>
                      <div class="alarm-time-list-bottom">
                        <div class="alarm-time-list-bottom-left">
                          <div class="startTime">{{ detail.arrivalTime }}</div>
                          <div>{{ detail.completionTime }}</div>
                        </div>
                        <div class="alarm-time-list-bottom-right">
                          {{getTimeSection(detail.arrivalTime, detail.completionTime)}}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="alarm-time-makespan">
                  <img src="../../assets/img/alarm/now-time-icon.png"
                       style="height: 20px; width: 20px; margin-right: 5px"/>
                  {{$t('label_253')}}
                  <span style="margin-left: 20px; font-size: 18px; font-weight: 600">
						{{ getTimeSection(detail.startTime, detail.completionTime) }}</span>
                </div>
              </div>
            </div>
            <el-dialog :visible.sync="dialogVisible" :center='true' :append-to-body='true' center>
              <div style='width:100%;text-align:center;'><img style="width: 100%; height: 600px;" :src='imgSrc'></div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "@/assets/css/alarm/list.css";
  import CommonJs from "@/assets/js/common/common.js";
  import Alarm from "@/assets/js/alarm/alarm.js";
  import Page from "@/components/common/page";
  import utils from "@/utils/utils.js";

  export default {
    name: "alarm",
    components: {
      Page,
    },
    data() {
      return {
        searchParam: {
          source: [],
          error: [],
          state: [],
          startTime: "",
          startTime2: "",
          customerType: "",
        },
        distribution: false,
        searchSwitch: false,
        details: false,
        alarmSourceList: [
          {
            id1: "1375360383395110913",
            dictId: "6",
            name: "システム発見",
            value1: null,
            value2: null,
            value3: null,
            value4: null,
            id: "0"
          },
          {
            id1: "1375360277195333633",
            dictId: "6",
            name: "修正依頼",
            value1: null,
            value2: null,
            value3: null,
            value4: null,
            id: "1"
          }
        ],
        menuList: [],
        alarmStateList: [
          {
            id1: "1375360486277193730",
            dictId: "7",
            name: "アラーム",
            value1: null,
            value2: null,
            value3: null,
            value4: null,
            id: "0"
          },
          {
            id1: "1375360535623180290",
            dictId: "7",
            name: "恢复",
            value1: null,
            value2: null,
            value3: null,
            value4: null,
            id: "1"
          }
        ],
        alarmTypeList: [
          {
            id1: "1375360953212280834",
            dictId: "8",
            name: "温度過昇",
            value1: null,
            value2: null,
            value3: null,
            value4: null,
            id: "3"
          }
        ],
        orderStateList: [
          {
            id1: "1382983350673317889",
            dictid1: "1381840897291407361",
            name: this.$t('label_142'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 0
          },
          {
            id1: "1382983389277691906",
            dictid1: "1381840897291407361",
            name: this.$t('btn_42'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 1
          },
          {
            id1: "1382983440565641218",
            dictid1: "1381840897291407361",
            name: this.$t('到场'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 2
          },
          {
            id1: "1382983472861782018",
            dictid1: "1381840897291407361",
            name: this.$t('label_322'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 3
          },
          {
            id1: "1402461226128670722",
            dictid1: "1381840897291407361",
            name: this.$t('label_430'),
            value1: "",
            value2: "",
            value3: "",
            alue4: "",
            id: 4
          },
          {
            id1: "1402461282957295618",
            dictid1: "1381840897291407361",
            value: this.$t('label_154'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 5
          },
          {
            id1: "1402426849315274753",
            dictid1: "1381840897291407361",
            name: this.$t('label_150'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 7
          },
          {
            id1: "1410052944446267393",
            dictid1: "1381840897291407361",
            name: this.$t('已分配'),
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            id: 8
          }
        ],
        customerTypeList: [],
        stateList: [],
        value: "",
        value1: "",
        checkList: [],
        tableData: [
          {
            id: "1681822106062262274",
            source: "0",
            state: "1",
            error: "3",
            content: "温度過昇警報",
            customerType: "0",
            customerName: "サテライトオフィス",
            contact: "鎌田 留美子",
            contactPhone: "13761244072",
            province: "神奈川",
            city: "横浜市",
            district: "港北区",
            town: "新横浜",
            address: "神奈川県横浜市港北区新横浜3-20-8",
            orderState: "0",
            supportPersonName: null,
            helperName: null,
            supportPerson: null,
            helper: null,
            workNotes: null,
            startTime: "2023-07-20 08:23:31",
            receiveTime: null,
            arrivalTime: null,
            completionTime: null,
            endTime: "2023-07-20 08:23:36",
            workOrderId: "1681822106062262275",
            workOrderState: null,
            workPics: null,
            deviceCode: "XA00600001",
            tagName: "温度設定",
            deviceAddress: "LG1消控中心",
            probeAddress: "新横浜3-120-8",
            name: "组合式空气处理机组B1-22区KT-B1-1"
          }, {
            id: "1681567565039374338",
            source: "0",
            state: "1",
            error: "3",
            content: "温度過昇警報",
            customerType: "0",
            customerName: "Network Corporation",
            contact: "金工",
            contactPhone: "13761244072",
            province: "神奈川",
            city: "横浜市",
            district: "港北区",
            town: "新横浜",
            address: "Xigang District, Dalian",
            orderState: "0",
            supportPersonName: null,
            helperName: null,
            supportPerson: null,
            helper: null,
            workNotes: null,
            startTime: "2023-07-19 15:32:04",
            receiveTime: null,
            arrivalTime: null,
            completionTime: null,
            endTime: "2023-07-19 15:32:05",
            workOrderId: "1681567565039374339",
            workOrderState: null,
            workPics: null,
            deviceCode: "XA00600001",
            tagName: "温度設定",
            deviceAddress: "新横浜1-20-8",
            probeAddress: "新横浜1-20-8",
            name: "组合式空气处理机组B1-22区KT-B1-1"
          },
          {
            id: "1681840742508367874",
            source: "0",
            state: "0",
            error: "3",
            content: "温度過昇警報",
            customerType: "0",
            customerName: "サテライトオフィス",
            contact: "鎌田 留美子",
            contactPhone: "13761180102",
            province: "神奈川",
            city: "横浜市",
            district: "港北区",
            town: "新横浜",
            address: "神奈川県横浜市港北区新横浜3-20-8",
            orderState: "0",
            supportPersonName: null,
            helperName: null,
            supportPerson: null,
            helper: null,
            workNotes: null,
            startTime: "2023-07-20 09:37:35",
            receiveTime: null,
            arrivalTime: null,
            completionTime: null,
            endTime: null,
            workOrderId: "1681840742508367875",
            workOrderState: null,
            workPics: null,
            deviceCode: "XA00700001",
            tagName: "温度設定",
            deviceAddress: "LGP2酒店监控室",
            probeAddress: "新横浜3-20-8",
            name: "组合式空气处理机组B1-22区KT-B1-1"
          }
        ],
        multipleSelection: [],
        pageCount: 3,
        pageNo: 1,
        pageSize: 10,
        detail: {
          id: "1681822106062262274",
          source: "0",
          state: "1",
          error: "3",
          content: "温度過昇警報",
          customerType: "0",
          customerName: "サテライトオフィス",
          contact: "鎌田 留美子",
          contactPhone: "13761244072",
          province: "神奈川",
          city: "横浜市",
          district: "港北区",
          town: "新横浜",
          address: "神奈川県横浜市港北区新横浜3-20-8",
          orderState: "0",
          supportPersonName: null,
          helperName: null,
          supportPerson: null,
          helper: null,
          workNotes: null,
          startTime: "2023-07-20 08:23:31",
          receiveTime: null,
          arrivalTime: null,
          completionTime: null,
          endTime: "2023-07-20 08:23:36",
          workOrderId: "1681822106062262275",
          workOrderState: null,
          workPics: null,
          deviceCode: "XA00600001",
          tagName: "温度設定",
          deviceAddress: "LG1消控中心",
          probeAddress: "新横浜3-120-8",
          name: "组合式空气处理机组B1-22区KT-B1-1"
        },
        supportPerson: "",
        helper: "",
        supportPersonId: "",
        helperId: "",
        workOrderState: [0, 4, 5],
        sheet: [{
          title: "报警表",
          tHeader: [
            "客户名称",
            "客户地址",
            "设备编号",
            "报警来源",
            "报警类型",
            "报警状态",
            "故障内容",
            "发生时间",
            "接单时间",
            "到场时间",
            "完成时间",
            "恢复时间",
            "工单状态",
            "负责人员",
            "维修人员",
            "备注",
          ],
          keys: [
            "customerName",
            "address",
            "deviceCode",
            "sourceName",
            "errorName",
            "stateName",
            "content",
            "startTime",
            "receiveTime",
            "arrivalTime",
            "completionTime",
            "endTime",
            "orderStateName",
            "supportPerson",
            "helper",
            "workNotes",
          ],
          table: [],
          sheetName: "报警",
          cellStyle: [{
            cell: "A1",
            font: {
              name: "黑体",
              sz: "18px",
            },
          },],
        },],
        timer: "",
        dialogVisible: false,
        imgSrc: '',
        countParam: {
          states: '0,1,2,7,4,5'
        },
      };
    },
    methods: {
      imgClickPics(imgSrc) {
        this.imgSrc = 'data:image/jpeg;base64,' + this.detail.pics[imgSrc];
        this.dialogVisible = true;
      },
      imgClick(imgSrc) {
        this.imgSrc = 'data:image/jpeg;base64,' + this.detail.workPics[imgSrc];
        this.dialogVisible = true;
      },
      tableRowClassName({
                          row,
                          rowIndex
                        }) {
        if (row.state == "0") {
          //this.muiscPlay1(1)
          return "warning-row";
        } else {
          //this.muiscPlay1(2)
          //this.gamemuiscs1.pause();
          return "";
        }
      },
      muiscPlay1(index) {
        this.gamemuiscs1 = new Audio(
          "https://www.sfrsafety.com/static/img/warn.wav"
        );
        if (index == 1) {
          this.gamemuiscs1.play();
        } else {
          this.gamemuiscs1.pause();
        }
      },
      getIndex(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1;
      },
      getImgList(index) {
        return "data:image/jpeg;base64," + index;
      },
      queryArea(item) {
        let param = {
          pageNo: 1,
          pageSize: this.pageSize,
        };
        if (item == "all") {
          this.$delete(this.searchParam, "city");
          this.$delete(this.searchParam, "district");
          this.search(param);
        } else {
          this.$delete(this.searchParam, "city");
          this.$delete(this.searchParam, "district");
          param = Object.assign(param, item);
          this.searchParam = Object.assign(this.searchParam, item);
          this.search(param);
        }

        if (item == "all" || item.city == "all") {
          item = {
            city: null,
          };
        }
        this.countParam = item;
        this.getCountByState(this.countParam);
      },
      queryStaff1(queryString, cb) {
        CommonJs.getUserByName(queryString)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              cb(data.data);
            }
          })
          .catch((response) => {
          });
      },
      queryStaff2(queryString, cb) {
        CommonJs.getUserByName(queryString)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              cb(data.data);
            }
          })
          .catch((response) => {
          });
      },
      selectStaff1(item) {
        this.supportPerson = item.fullName;
        this.supportPersonId = item.userId;
      },
      selectStaff2(item) {
        this.helper = item.fullName;
        this.helperId = item.userId;
      },
      async getCustomerTypeList() {
        await CommonJs.getDict("客户类型")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                list.push(param);
              });
              this.customerTypeList = list;
            }
          })
          .catch((response) => {
          });
      },
      async getAlarmTypeList() {
        await CommonJs.getDict("报警类型")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              let checkBox = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                list.push(param);
                checkBox.push(item.rank);
              });
              this.alarmTypeList = list;
              this.searchParam.error = checkBox;
            }
          })
          .catch((response) => {
          });
      },
      async getAlarmStateList() {
        await CommonJs.getDict("报警状态")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              let checkBox = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                list.push(param);
                checkBox.push(item.rank);
              });
              this.searchParam.state = checkBox;
              this.alarmStateList = list;
            }
          })
          .catch((response) => {
          });
      },
      async getAlarmSourceList() {
        await CommonJs.getDict("报警来源")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              let checkBox = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                list.push(param);
                checkBox.push(item.rank);
              });
              this.searchParam.source = checkBox;
              this.alarmSourceList = list;
            }
          })
          .catch((response) => {
          });
      },
      async getOrderStateList() {
        await CommonJs.getDict("工单状态")
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              let list = [];
              data.data.forEach(function (item, index) {
                var param = {};
                param.id = item.rank;
                param.name = item.value;
                list.push(param);
              });
              this.orderStateList = list;
            }
          })
          .catch((response) => {
          });
      },
      async getCountByState(param) {
        // let param = [0, 4, 5];
        param.states = '0,1,2,7,4,5';
        for (let a in param) {
          if (Array.isArray(param[a])) {
            param[a] = param[a][0];
          }
        }
        await Alarm.getCountByState(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              this.stateList = data.data;
            }
          })
          .catch((response) => {
          });
      },
      searchState(state) {
        if (this.workOrderState.indexOf(state) >= 0) {
          this.workOrderState.forEach((item, index) => {
            if (item === state) {
              if (this.workOrderState.length !== 1) {
                this.workOrderState.splice(index, 1);
              }
            }
          });
        } else {
          this.workOrderState.push(state);
        }
      },
      searchSwitchChange() {
        this.timing();
      },
      timing() {
        let $this = this;
        $this.utils.clearTime();
        this.$nextTick(() => {
          if ($this.searchSwitch) {
            $this.utils.timing(function () {
              $this.getCountByState($this.countParam);
              $this.search({
                pageNo: 1,
                pageSize: $this.pageSize,
              });
            }, 10000);
          }
        })
      },
      clickState(state) {
        this.searchParam.state.forEach((item, index) => {
          if (item === state) {
            if (this.searchParam.state.length > 1) {
              this.searchParam.state.splice(index, 1);
            }
          } else {
            if (this.searchParam.state.length === 1) {
              this.searchParam.state.push(state);
            }
          }
        });
      },
      clickSource(state) {
        this.searchParam.source.forEach((item, index) => {
          if (item === state) {
            if (this.searchParam.source.length > 1) {
              this.searchParam.source.splice(index, 1);
            }
          } else {
            if (this.searchParam.source.length === 1) {
              this.searchParam.source.push(state);
            }
          }
        });
      },
      search(param) {
        // console.log(param);
        utils.startLoading();
        param.source = this.searchParam.source;
        param.state = this.searchParam.state;
        if (this.searchParam.error.length > 0) {
          param.error = this.searchParam.error;
        }
        if (
          this.searchParam.startTime != "" &&
          this.searchParam.startTime != null &&
          this.searchParam.startTime2 != "" &&
          this.searchParam.startTime2 != null
        ) {
          param.startTime = this.searchParam.startTime;
          param.startTime2 = this.searchParam.startTime2;
        } else {
          if (
            (this.searchParam.startTime != "" &&
              this.searchParam.startTime != null) ||
            (this.searchParam.startTime2 != "" &&
              this.searchParam.startTime2 != null)
          ) {
            utils.tipsAlert("请选择开始与结束日期");
            utils.messageAlert(this.$t('msg_229'), this.$t('label_358'), this.$t('label_100'));
          }
        }
        if (
          this.searchParam.district != "" &&
          this.searchParam.district != undefined
        ) {
          param.district = this.searchParam.district;
        }
        if (this.searchParam.customerType !== "") {
          param.customerType = this.searchParam.customerType;
        }
        if (this.workOrderState.length > 0) {
          param.workOrderState = this.workOrderState;
        }
        this.post(param);
        //this.getExcelList(param);
        this.timing();
      },
      post(param) {
        Alarm.getAlarm(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              utils.endLoading();
              this.pageCount = data.data.total;
              this.pageNo = data.data.current;
              this.$refs["pageModel"].setCurrent(this.pageNo);
              this.tableData = data.data.records;
            }
          })
          .catch((response) => {
          });
      },
      getExcelList(param) {
        Alarm.getExcel(param)
          .then((response) => {
            const data = response.data;
            //console.log("getExcelList:" + JSON.stringify(data));
            if (data.code == 1) {
              var list = [];
              var $this = this;
              data.data.forEach(function (item, index) {
                var newItem = {};
                newItem.customerName =
                  item.customerName == null ? " " : item.customerName;
                newItem.address = item.address == null ? " " : item.address;
                newItem.content = item.content == null ? " " : item.content;
                newItem.startTime = item.startTime == null ? " " : item.startTime;
                newItem.receiveTime =
                  item.receiveTime == null ? " " : item.receiveTime;
                newItem.arrivalTime =
                  item.arrivalTime == null ? " " : item.arrivalTime;
                newItem.completionTime =
                  item.completionTime == null ? " " : item.completionTime;
                newItem.endTime = item.endTime == null ? " " : item.endTime;
                newItem.supportPerson =
                  item.supportPerson == null ? " " : item.supportPerson;
                newItem.helper = item.helper == null ? " " : item.helper;
                newItem.workNotes = item.workNotes == null ? " " : item.workNotes;
                newItem.deviceCode = item.deviceCode == null ? " " : item.deviceCode;
                $this.alarmStateList.forEach(function (item1, index1) {
                  if (item.state === item1.id + "") {
                    newItem.stateName = item1.name;
                  }
                });
                $this.alarmSourceList.forEach(function (item1, index1) {
                  if (item.source === item1.id + "") {
                    newItem.sourceName = item1.name;
                  }
                });
                $this.alarmTypeList.forEach(function (item1, index1) {
                  if (item.error === item1.id + "") {
                    newItem.errorName = item1.name;
                  }
                });
                $this.orderStateList.forEach(function (item1, index1) {
                  if (item.orderState === item1.id + "") {
                    newItem.orderStateName = item1.name;
                  }
                });

                list.push(newItem);
              });
              this.sheet[0].table = list;

            }
            // console.log("table:" + JSON.stringify(this.sheet[0].table));
          })
          .catch((response) => {
          });
      },
      handleCurrentChange(val) {
        if (val == null) {
          return;
        }
        this.detail = val;
        let param = {};
        param.id = val.id;
        Alarm.getInfo(param)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              if (data.data == null) {
                utils.tipsAlert(
                  "您未绑定该客户，请前往“人员管理”模块进行绑定"
                );
              } else {
                this.detail = data.data;
                if (this.detail.workPics != null && this.detail.workPics != '') {
                  this.detail.workPics = this.detail.workPics.split(",");
                }
                if (this.detail.pics != null && this.detail.pics != '') {
                  this.detail.pics = this.detail.pics.split(",");
                }
              }
            }
          })
          .catch((response) => {
          });
      },
      showDetails() {
        /*if (Object.keys(this.detail).length > 0) {*/
        this.details = true;
        this.searchSwitch = false;
        /*} else {
        utils.tipsAlert(this.$t('input_38'));
        }*/
      },
      showDistribution() {
        // if (Object.keys(this.detail).length > 0) {
        // if (this.detail.workOrderState > 1 && this.detail.workOrderState <= 3) {
        // 	utils.tipsAlert("已完成的订单不可被再次分配");
        // } else if (
        // 	this.detail.supportPerson != null &&
        // 	this.detail.supportPerson != "" &&
        // 	this.detail.helper != null &&
        // 	this.detail.helper != ""
        // ) {
        // 	utils.tipsAlert("已有维修人员不可被再次分配");
        // } else {
        this.distribution = true;
        // this.supportPersonId = this.detail.supportPerson;
        // this.supportPerson = this.detail.supportPersonName;
        // this.helperId = this.detail.helper;
        // this.helper = this.detail.helperName;
        // 	}
        // } else {
        // 	utils.tipsAlert(this.$t('input_38'));
        // }
      },
      editAlarm() {
        let param = {};
        param.alarmId = this.detail.id;
        param.id = this.detail.workOrderId;
        param.supportPerson = this.supportPersonId;
        param.helper = this.helperId;
        param.state = "8";
        if (
          this.supportPersonId == null ||
          this.supportPersonId == undefined ||
          this.supportPersonId == "" ||
          this.helperId == null ||
          this.helperId == undefined ||
          this.helperId == ""
        ) {
          utils.tipsAlert("请选择“负责人员”和“协同人员”");
        } else {
          Alarm.editAlarm(param)
            .then((response) => {
              const data = response.data;
              if (data.code == 1) {
                utils.tipsAlert("分配成功");
                this.distribution = false;
                this.search({
                  pageNo: 1,
                  pageSize: this.pageSize,
                });
              }
            })
            .catch((response) => {
              console.log(response);
            });
        }
      },
      getTimeSection(startTime, endTime) {
        if (endTime == null) {
          return "--";
        }
        let timeSection =
          this.getTimeString(endTime) - this.getTimeString(startTime);
        let getDay = parseInt(timeSection / 1000 / 60 / 60 / 24);
        let day = "";
        if (getDay > 0) {
          day = getDay + "天";
        }
        let getTime = new Date(timeSection - 1000 * 60 * 60 * 8);

        return (
          day +
          this.b0(getTime.getHours()) +
          ":" +
          this.b0(getTime.getMinutes()) +
          ":" +
          this.b0(getTime.getSeconds())
        );
      },
      b0(time) {
        if (time < 10) {
          return "0" + time;
        }
        return time;
      },
      getCountTimeSection(time1, time2, time3, time4, time5) {
        if (time5 == null) {
          if (time4 == null) {
            if (time3 == null) {
              if (time2 == null) {
                return this.getTimeSection(time1);
              }
              return this.getTimeSection(time1, time2);
            }
            return this.getTimeSection(time1, time3);
          }
          return this.getTimeSection(time1, time4);
        }
        return this.getTimeSection(time1, time5);
      },
      getTimeString(time) {
        let timeString = new Date(time).getTime();
        return timeString;
      },
      getPreDay() {
        //alert("1");
        var time = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
        var yesterday = new Date(time);
        var year = yesterday.getFullYear();
        //alert(year);
        var month = yesterday.getMonth();
        var day = yesterday.getDate();
        yesterday =
          yesterday.getFullYear() +
          "-" +
          (yesterday.getMonth() >= 9 ?
            yesterday.getMonth() + 1 :
            "0" + (yesterday.getMonth() + 1)) +
          "-" +
          (yesterday.getDate() > 9 ?
            yesterday.getDate() :
            "0" + yesterday.getDate());
        return yesterday;
      },
      getDay() {
        var time = new Date().getTime();
        var yesterday = new Date(time);
        var month = yesterday.getMonth();
        var day = yesterday.getDate();
        yesterday =
          yesterday.getFullYear() +
          "-" +
          (yesterday.getMonth() >= 9 ?
            yesterday.getMonth() + 1 :
            "0" + (yesterday.getMonth() + 1)) +
          "-" +
          (yesterday.getDate() > 9 ?
            yesterday.getDate() :
            "0" + yesterday.getDate());
        return yesterday;
      },
    },
    created() {
      /*this.getCustomerTypeList();
      this.getAlarmTypeList();
      this.getAlarmStateList();
      this.getAlarmSourceList();
      this.getOrderStateList();
      this.countParam = {
        city: null
      };
      this.getCountByState(this.countParam);
*/
      this.menuList = this.$store.getters.getMenuPermission;
    },
    mounted() {
      /*this.timer = setTimeout(() => {
        this.search({
          pageNo: 1,
          pageSize: this.pageSize,
        });
      }, 10000);*/
      this.searchParam.startTime2 = this.getDay();
      this.searchParam.startTime = this.getPreDay();
    },
    beforeDestroy() {
      clearTimeout(this.timer);
      utils.clearTime();
    },
  };
</script>
<style>
  .user-input {
  }

  .alarm-time-list-top-left > .line.incomplete {
    border-bottom: 2px solid #ddd;
  }

  .alarm-search-condition .date-class.el-date-editor.el-input {
    height: 30px;
    width: 150px;
  }

  .alarm-search-condition .date-class .el-input__inner {
    border: 0;
    background-color: #f5f5f5;
    height: 30px;
    border-radius: 15px;
  }

  .alarm-search-condition .date-class .el-range-input {
    background-color: #f5f5f5;
  }

  .alarm-search-condition .date-class .el-input__icon {
    line-height: 30px;
  }

  .alarm-search-condition .select-class .el-input__icon {
    line-height: 30px;
  }

  .search2-checkbox.is-checked .el-checkbox__inner {
    background-color: #2bbc86;
    border-color: #2bbc86;
  }

  .search2-checkbox .el-checkbox__label {
    display: none;
  }

  .list-table .el-table__body tr.current-row > td {
    background-color: #f5f5f5 !important;
  }

  .alarm-search-2 li {
    position: relative;
  }

  .overtime {
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(../../assets/img/alarm/overtime-icon.png);
    background-size: 100% 100%;
    z-index: 110;
    width: 80px;
    height: 16px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }

  .searchSwitch {
    width: 200px;
    text-align: center;
    font-weight: 600;
    padding-left: 20px;
    color: #ffffff;
    cursor: pointer;
  }

  .list-table .el-table__body-wrapper .el-table__body tbody .warning-row td {
    -webkit-animation: infinite bgcolor 1s ease;
    -moz-animation: infinite bgcolor 1s ease;
    animation: infinite bgcolor 1s ease;
    color: #f48164;
    font-weight: bold;
  }

  @-webkit-keyframes bgcolor {
    0% {
      background-color: #fff1ed;
    }

    50% {
      background-color: #f5fff8;
    }
  }

  @-moz-keyframes bgcolor {
    0% {
      background-color: #fff1ed;
    }

    50% {
      background-color: #f5fff8;
    }
  }

  @keyframes bgcolor {
    0% {
      background-color: #fff1ed;
    }

    50% {
      background-color: #f5fff8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/homepage/timeFault.vue